/**
 * this file defines global constants, which are used across the project
 */
export const URL = {
    /**
   * API Url
   */
    // API_URL: `http://192.168.1.155:9000/game`,
    API_URL: `${process.env.API}/game`,
    ASSETS_URL: process.env.ASSETS_URL,
};

/**
 * resource path for assets
 */
export const ASSETS_PATH = {
    IMAGES: `${URL.ASSETS_URL}/assets/images`,
    SOUNDS: `${URL.ASSETS_URL}/assets/sounds`,
    LANGUAGE: `${URL.ASSETS_URL}/assets/language`,
    FONTS: `${URL.ASSETS_URL}/assets/fonts`,
    STYLES: `${URL.ASSETS_URL}/assets/styles`,
    SPINE: `${URL.ASSETS_URL}/assets/spin`,
    NEUTRINO: `${URL.ASSETS_URL}/neutrino`,
};

export const ASSETS_VERSION = process.env.ASSETS_VERSION
    ? process.env.ASSETS_VERSION
    : '';

/**
 * key of game data
 */
export const GAME_DATA_KEY = {
    BET: 'bet',
    LINES: 'lines',
    TOTALBET: 'totalBet',
    COINS: 'coins',
    LASTWIN: 'lastWin',
    LASTEXPANDINGWIN: 'lastExpandingWin',
    FREEGAMEWIN: 'FGWin',
    FREEGAMECOUNTERMAX: 'FGCounterMax',
    FREEGAMECOUNTER: 'FGCounter',
    WIN: 'wins',
    FREESPIN: 'freeSpinData',
    SPECIALSPIN: 'specialSpinData',
    GAMBLEGAMECOLLECTED: 'GGCollected',
    GAMBLEGAMEWIN: 'GGWin',
    GIFTSPINCOUNTERMAX: 'GSCounterMax',
    GIFTSPINCOUNTER: 'GSCounter',
};

/**
 * keys of game property
 */
export const GAME_PROPERTY_KEY = {
    DEMO: 'demoPlay',
    FREEGAMEPRESTART: 'freeGamePreStart',
    TURBOCHECKED: 'isTurboChecked',
    AUTOTURBOCHECKED: 'isAutoTurboChecked',
    AUTOSPIN: 'isAutospin',
    FREEGAME: 'isFreeGame',
    GAMBLEGAME: 'isGambleGame',
    PPOPEN: 'isPPOpen',
    PPALLOWED: 'isPPAllowed',
    GAMBLEACTIVE: 'isGambleActive',
    EXPANDINGSYMBOL: 'expandingSymbol',
    POPUPDIALOGUEOPEN: 'isPopupDialogueOpen',
    LOCALIZATION: 'localization',
    MUSICENABLED: 'musicEnabled',
    SOUNDENABLED: 'soundEnabled',
};

export const GAME_EVENT_URL = {
    INCREASEBET: `${URL.API_URL}/game_event?event=increaseBet`,
    DECREASEBET: `${URL.API_URL}/game_event?event=decreaseBet`,
    MAXBET: `${URL.API_URL}/game_event?event=maxBet`,
    INCREASEBETLINE: `${URL.API_URL}/game_event?event=increaseBetLine`,
    DECREASEBETLINE: `${URL.API_URL}/game_event?event=decreaseBetLine`,
    SPIN: `${URL.API_URL}/spin`,
    GAME_CLICK: `${URL.API_URL}/game_click`,
    GAMBLE_CARD: `${URL.API_URL}/soa/gamble`,
    TAKEWIN: `${URL.API_URL}/soa/pick`,
    UPDATE_EVENT: `${URL.API_URL}/event`,
    GAME_SESSION: `${URL.API_URL}/session`,
};
/**
 * game id
 */
export const GAME_ID = '3f75d8e3-5367-4bfa-a728-8b220b49be1e';

export const RANDOM_STRING = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const KEY = '16fdec0a-0326-4ab1-97ec-c2d741b36c43';

export const DEFAULT_USER_DATA = {
    gameId: GAME_ID,
    clientID: '',
    wallet: 100000,
    walletWithoutAd: 50000,
    currentBet: 500,
    freeSpinData: {},
};

/**
 * symbol id
 */
export const SYMBOL_ID = {
    TEN: '16fdec0a-0326-4ab1-97ec-c2d741b36c43',
    J: '178c355d-be2c-4d59-8f22-2faddf5afe2b',
    Q: '848cf1a8-d34c-451f-9971-eda7d0e4c098',
    K: '10b4429d-ccc5-4f9a-ab98-23d58dd350ae',
    A: 'ade3d887-022a-4883-9ef6-87d49c806d65',
    GOD: '48414f73-a9a4-4de0-bc68-dcca8b449981',
    HUNTER: '2d569e83-111a-4c83-bdc4-b486c1ac1474',
    TUTANKHAMON: '4b6c4eeb-1cf7-45d0-9e04-fb954813953d',
    SCARAB: '39cc36e5-ea8c-4dcd-abef-3d2f23a20257',
    WILD: '5c664da3-68ec-49a5-8ae8-6475af17d50d',
    SCATTER: 'a5b29801-ff1a-4be6-98b1-7d8912292d71',
};

/**
 * reels
 */
export const REELS = {
    REEL1: 'reel1',
    REEL2: 'reel2',
    REEL3: 'reel3',
    REEL4: 'reel4',
    REEL5: 'reel5',
};

/**
 * error constants
 */
export const GAMBLE_CARD_COLOR = {
    RED: 'red',
    BLACK: 'black',
};

/**
 * error message form server
 */
export const SERVER_ERROR_MESSAGE = {
    NOT_FOUND: 'Requested resource not found on server',
    FAILED_AUTHENTICATION: 'failed to authenticate token',
    SOMETHING_WENT_WRONG: 'something went wrong, please try again.',
    INVALID_GAME_EVENT: 'invalid game event',
    NO_SESSION_DATA: 'could not fetch session data, please try again.',
    NO_PAYTABLE: 'could not fetch pay table, please try again.',
    SPIN_NOT_ALLOWED: 'spin not allowed right now',
    SPIN_NOT_ALLOWED_NO_GAME_CLICK: 'spin not allowed right now as game click did not happen',
    SPIN_FAILED: 'could not spin right now, an unexpected error occured, please try again.',
    GAME_NOT_FOUND: 'could not find any game from given id',
    UNRECOGNIZED_USER: 'could not recognize user',
    INVALID_SYMBOL: 'this symbol id is invalid',
    NO_USER_SESSION: 'user session is not active',
    NO_VERSION: 'no version found for the given platform',
    NOT_ENOUGH_BALANCE: 'not enough balance',
    GAMEDEACTIVATED: 'invalid client',
};

/**
 * error constants
 */
export const ERROR = {
    UNDEFINED: 'ERROR.UNDEFINED',
    TOKEN_UNDEFINED: 'ERROR.TOKEN_UNDEFINED',
    DISCONNECTED: 'SERVER.DISCONNECTED',
    NETWORK: 'ERROR.NETWORK',
    NOMONEY: 'ERROR.NOMONEY',
    GAMEDEACTIVATED: 'ERROR.GAMEDEACTIVATED',
    NOT_FOUND: 'ERROR.NOT_FOUND',
    SOMETHING_WENT_WRONG: 'ERROR.SOMETHING_WENT_WRONG',
    INVALID_GAME_EVENT: 'ERROR.INVALID_GAME_EVENT',
    NO_SESSION_DATA: 'ERROR.NO_SESSION_DATA',
    SPIN_NOT_ALLOWED: 'ERROR.SPIN_NOT_ALLOWED',
    SPIN_NOT_ALLOWED_NO_GAME_CLICK: 'ERROR.SPIN_NOT_ALLOWED_NO_GAME_CLICK',
    SPIN_FAILED: 'ERROR.SPIN_FAILED',
    GAME_NOT_FOUND: 'ERROR.GAME_NOT_FOUND',
    UNRECOGNIZED_USER: 'ERROR.UNRECOGNIZED_USER',
    NOT_ENOUGH_BALANCE: 'ERROR.NOT_ENOUGH_BALANCE',
    GAMBLE_NOT_ACTIVE: 'ERROR.GAMBLE_NOT_ACTIVE',
    NO_WINS_TO_COLLECT: 'ERROR.NO_WINS_TO_COLLECT',
    INVALID_CLIENT: 'ERROR.INVALID_CLIENT',
    INVALID_GAMBLE_CARD: 'ERROR.INVALID_GAMBLE_CARD',
};
